/* unplugin-vue-components disabled */import script from "./honorSwiperBox.vue?vue&type=script&lang=jsx"
export * from "./honorSwiperBox.vue?vue&type=script&lang=jsx"

import "./honorSwiperBox.vue?vue&type=style&index=0&id=73e74dbb&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73e74dbb"]])

export default __exports__